import { Component } from "react"
import { Outlet } from "react-router-dom"
import PropTypes from "prop-types"
import { PERIOD, DATE } from "helpers/shapes"
import { getDefaultDateRangeProps } from "helpers/shareMyView"
import FactorTrendsHeader from "modules/factor-trends-header"

import "./style.scss"

export default class FactorTrends extends Component {
  static propTypes = {
    account: PropTypes.string.isRequired,
    modelId: PropTypes.string.isRequired,
    earliestDate: DATE,
    latestDate: DATE,
    startDate: DATE,
    endDate: DATE,
    firstDate: DATE,
    selectedDate: DATE,
    period: PERIOD.isRequired,
    setPeriod: PropTypes.func.isRequired,
    setDate: PropTypes.func.isRequired,
    resetDate: PropTypes.func.isRequired,
    datesAdjusted: PropTypes.bool.isRequired,
    addNotification: PropTypes.func.isRequired,
    selectDisplayType: PropTypes.func.isRequired,
    displayAddView: PropTypes.bool.isRequired,
    setShareMyViewProps: PropTypes.func.isRequired,
  }

  componentDidUpdate() {
    const { firstDate, startDate: propsStartDate, selectedDate } = this.props
    const startDate = firstDate || propsStartDate

    if (selectedDate && (selectedDate < startDate)) {
      this.props.resetDate()
    }
  }

  componentDidMount() {
    const { setShareMyViewProps, period, startDate, endDate } = this.props
    setShareMyViewProps(getDefaultDateRangeProps(period, startDate, endDate))
  }

  render() {
    const {
      account,
      modelId,
      earliestDate,
      latestDate,
      setDate,
      selectedDate,
      startDate,
      endDate,
      firstDate,
      datesAdjusted,
      period,
      resetDate,
      setPeriod,
      addNotification,
      selectDisplayType,
      displayAddView,
    } = this.props

    return <div className="modules_factor-trends">
      <FactorTrendsHeader
        noSpinner
        selectedId="performance"
        {...{
          account,
          adjusted: datesAdjusted,
          earliestDate,
          latestDate,
          startDate,
          endDate,
          selectedDate,
          period,
          setPeriod,
          addNotification,
          resetDate,
          firstDate,
          selectDisplayType,
        }}
      />

      <Outlet context={{
        account,
        modelId,
        period,
        setDate,
        resetDate,
        displayAddView,
      }}
      />
    </div>
  }
}
